import { useCallback, useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { IconArrowDiagonal, IconTwoArrows, IconLoader } from '@ui/src';
// import {
//   Area,
//   AreaChart,
//   CartesianGrid,
//   ResponsiveContainer,
//   XAxis,
//   YAxis,
// } from 'recharts';
import { useAppDispatch } from '@store';
import { getNameCustomer } from '../../helpers/get-name';
import { useLazyGetCustomersListQuery } from '../../hoc/dashboard/store/services';
import {
  // ViewMode,
  DashboardItemProps,
  DashboardValue,
  Period,
} from '../../hoc/dashboard/types';
import { getValueById } from '../../hoc/dashboard/store/slice';
import DashboardValuesControls from './dashboard-values-controls';

import cn from './dashboard.module.css';

const getQuery = ({ period, date }: { period?: Period; date: string[] }) => {
  let query = '?';

  if (period) {
    query += `period=${period.toLowerCase()}`;
  }
  if (date && date[0]) {
    query += `&createdAtFrom=${date[0]}`;
  }
  if (date && date[1]) {
    query += `&createdAtTo=${date[1]}`;
  }

  return query;
};

const DashboardCustomers = ({
  // viewMode,
  values,
  // setRightSideVisible,
  setSelectedChart,
  selectedChart,
}: DashboardItemProps) => {
  const [selectedDate, setSelectedDate] = useState<string[]>([]);
  const [period, setPeriod] = useState<Period | undefined>(Period.TODAY);

  const dispatch = useAppDispatch();

  const [getCustomers, { isLoading, isFetching }] =
    useLazyGetCustomersListQuery();

  const query = useMemo(
    () => getQuery({ period, date: selectedDate }),
    [period, selectedDate],
  );

  const getCustomersAction = useCallback(() => {
    getCustomers(query);
  }, [query]);

  useEffect(() => {
    getCustomersAction();
  }, [query]);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.dashboardValuesLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <div className={cn.dashboardValuesContent}>
        {isFetching && (
          <div className={cn.dashboardValuesRefetch}>
            <IconLoader />
          </div>
        )}
        {values?.map((item: DashboardValue) => (
          <button
            className={cn.dashboardValue}
            key={item.name}
            type="button"
            onClick={() => {
              setSelectedChart({
                value: item,
                period,
                dates: selectedDate,
              });

              dispatch(
                getValueById({
                  period,
                  dates: selectedDate,
                }),
              );

              // if (viewMode === ViewMode.GRID) {
              //   setRightSideVisible(true);
              // }
            }}
          >
            <div className={cn.dashboardValueNameWrapper}>
              <div className={cn.dashboardValueName}>
                {getNameCustomer(item.name)}
              </div>
            </div>
            <div className={cn.dashboardValueRight}>
              <div className={cn.dashboardValueRightItem}>{item.count}</div>
              <div
                className={cn.dashboardValueRightItem}
              >{`${item.percent}%`}</div>
              {/* <div
                className={`${cn.dashboardValueRightItem} ${
                  cn.dashboardGraph
                }`}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart height={70} width={189} data={item.data}>
                    <CartesianGrid horizontal={false} vertical={false} />
                    <XAxis
                      dataKey="name"
                      tickLine={false}
                      axisLine={false}
                      tick={false}
                    />
                    <YAxis
                      dataKey="value"
                      tickLine={false}
                      axisLine={false}
                      tick={false}
                    />

                    <defs>
                      <linearGradient
                        id={`gradient-${item.name}`}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor="#D1DDE9"
                          stopOpacity={0.6}
                        />
                        <stop
                          offset="100%"
                          stopColor="#D1DDE9"
                          stopOpacity={0.2}
                        />
                      </linearGradient>
                    </defs>
                    <Area
                      dataKey="value"
                      stroke="#9ea7ae"
                      fillOpacity={1}
                      fill={`url(#gradient-${item.name})`}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div> */}
            </div>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      // viewMode === ViewMode.GRID ? cn.dashboardValuesGrid : ''
      className={`${cn.dashboardValues} ${cn.dashboardValuesGrid}`}
    >
      <NavLink
        to="/customers/individual/list"
        className={cn.dashboardValuesTitle}
      >
        <div className={cn.dashboardValuesTitleIcon}>
          <IconTwoArrows />
        </div>
        <div className={cn.dashboardValuesTitleText}>Customers</div>
        <div className={cn.dashboardValuesTitleArrow}>
          <IconArrowDiagonal />
        </div>
      </NavLink>
      <DashboardValuesControls
        // viewMode={viewMode}
        period={period}
        setPeriod={(nextPeriod) => {
          setPeriod(nextPeriod);
          setSelectedDate([]);

          if (selectedChart) {
            setSelectedChart({ ...selectedChart, period: nextPeriod });
          }
        }}
        setSelectedDate={(dates) => {
          setSelectedDate(dates);

          if (selectedChart) {
            setSelectedChart({ ...selectedChart, dates });
          }
        }}
        selectedDate={selectedDate}
      />
      {content}
    </div>
  );
};

export default DashboardCustomers;
